function validateInput(id) {

    var $e = $('#' + id);
    var val = $e.val() || '';

    var isError = false;
    var _ErrorClass = 'dl-zip-error';
    var _ErrorMessage = 'The zip code entered was invalid. Please try again.';

    if (val.length <= 0) {
        isError = true;
        $e.addClass(_ErrorClass);
        $e.focus();
        $('#tabZipError').html(_ErrorMessage);
    } else {
        $e.removeClass(_ErrorClass);
        $('#tabZipError').html('');
    }

    if ((id == 'zipCodeInput' || id == 'dl-no-zip-input' || id == 'dl-no-zip-input-mobile')) {

        if (val.length != 5) {
            isError = true;
            $e.addClass(_ErrorClass);
            $e.focus();
            $('#tabZipError').html(_ErrorMessage);
        } else {
            $e.removeClass(_ErrorClass);
            $('#tabZipError').html('');
        }
    }

    return !isError;
};



//only 5 digits for zip input
$(function () {
    $('#zipCodeInput, #dl-no-zip-input-mobile, #dl-no-zip-input').on('input', function () {
        var e = this;
        if (e.value.length > e.maxLength) e.value = e.value.slice(0, e.maxLength);
    });
});